import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import { getFilename } from "./AssetUris";
export function isImageType(type) {
  return /^(jpeg|jpg|gif|png|bmp|webp|heic)$/i.test(type);
}
export function getImageInfoAsync(url) {
  return new Promise(function (resolve, reject) {
    var img = new Image();
    img.onerror = reject;

    img.onload = function () {
      resolve({
        name: getFilename(url),
        width: img.naturalWidth,
        height: img.naturalHeight
      });
    };

    img.src = url;
  });
}